import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageDataService } from '@ecap3/core';
import { Injectable } from '@angular/core';
import * as JSZip from 'jszip';
import * as FileSaver from 'file-saver';
import { DocumentManagerService } from 'src/app/business/app-platform-document-manager';
import { DriveFile } from 'src/app/business/app-platform-document-manager/models/DriveFile';
import { DriveFolder } from 'src/app/business/app-platform-document-manager/models/DriveFolder';

@Injectable({
    providedIn: 'root'
})
export class ZipDownloadService {
    constructor(
        private storageService: StorageDataService,
        private httpClient: HttpClient,
        private documentManagerService: DocumentManagerService
    ) {}

    private async getFile(FileStorageIds: string[]) {
        return this.storageService.getFilesInfo(FileStorageIds).pipe(
            map((response: any) => {
                return response.body;
            })
        );
    }

    private async getBlobFile(url) {
        const httpOptions = {
            responseType: 'blob' as 'json'
        };
        const res = await firstValueFrom(this.httpClient
            .get(url, httpOptions))
            .catch((err: HttpErrorResponse) => {
                const error = err.error;
                console.log(error);

                return error;
            });
        return res;
    }

    async createZip(
        files: any[],
        folders: any[],
        zipName: string,
        ModuleWorkspaceId
    ) {
        const name = zipName + '.zip';
        const zip = new JSZip();
        if (files.length > 0) await this.createZipFiles(files, zip);
        if (folders.length > 0)
            await this.createZipFolders(folders, zip, ModuleWorkspaceId);

        zip.generateAsync({ type: 'blob' }).then((content) => {
            if (content) {
                FileSaver.saveAs(content, name);
            }
        });
    }

    private async createZipFiles(files, currentZip) {
        let fileIds = files.map((item) => item.FileStorageId);
        const fileDataInfo: any = await firstValueFrom(await this.getFile(fileIds));
        
        for (const data of fileDataInfo) {
            const fileData: any = await this.getBlobFile(data.Url);
            const b: any = new Blob([fileData], {
                type: '' + fileData.type + ''
            });
            currentZip.file(data.Name, b);
        }
    }

    private async createZipFolders(folders, zip, ModuleWorkspaceId) {
        if (folders.length <= 0) return;

        for (const currentFolder of folders) {
            const currentZipFolder = zip.folder(currentFolder.Name);
            await this.GetAllDocuments(
                currentFolder.ItemId,
                ModuleWorkspaceId
            ).then(async (resp: any) => {
                const { Folders: subFolders, Files: files } = resp;
                await this.createZipFiles(files, currentZipFolder);
                if (subFolders.length) {
                    await this.createZipFolders(
                        subFolders,
                        currentZipFolder,
                        ModuleWorkspaceId
                    );
                }
                return;
            });
        }
        return;
    }

    private async GetAllDocuments(ParentId, ModuleWorkspaceId) {
        return new Promise<any>((resolve, reject) => {
            const promises = [];

            promises.push(
                this.documentManagerService.GetFiles(
                    ParentId,
                    ModuleWorkspaceId,
                    '',
                    null,
                    0,
                    100,
                    null
                )
            );
            promises.push(
                this.documentManagerService.GetFolders(
                    ParentId,
                    ModuleWorkspaceId,
                    '',
                    null,
                    0,
                    100,
                    null
                )
            );

            Promise.all(promises).then(
                (CombinedResp) => {
                    console.log(CombinedResp);
                    const files: DriveFile[] = [];
                    const folders: DriveFolder[] = [];
                    CombinedResp[0].forEach((file) => {
                        files.push(
                            new DriveFile(
                                file.ParentId,
                                file.IsFavorite,
                                file.OwnerName,
                                file.SharedByUserName,
                                '',
                                '',
                                file.ItemId,
                                '',
                                file.Name,
                                file.Description,
                                '',
                                file.CreateDate,
                                file.FileStorageId,
                                file.OrganizationId,
                                file.FileSizeInByte
                            )
                        );
                    });
                    CombinedResp[1].forEach((folder) => {
                        folders.push(
                            new DriveFolder(
                                folder.ParentId,
                                folder.IsFavorite,
                                folder.OwnerName,
                                folder.SharedByUserName,
                                '',
                                '',
                                folder.OrganizationId,
                                folder.ItemId,
                                folder.Name,
                                folder.Description,
                                folder.Color,
                                folder.CreateDate,
                                folder.SharedUserIdList,
                                folder.SharedRoleList,
                                ''
                            )
                        );
                    });
                    resolve({
                        Folders: folders,
                        Files: files
                    });
                },
                (error) => {
                    reject(new Error(error));
                }
            );
        });
    }
}
